import axios from "axios";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { SupplierAddSchema } from "../../../ValidationSchema";
import ReactSelect from "../../../Components/PortalSelect";

const colourStyles = {
  control: (styles) => ({
    ...styles,
    border: "1px solid #bfc9d4",
    boxShadow: "#000 !important",
    borderRadius: "6px",
    padding: "4px",
    "&:hover": {
      border: "1px solid #bfc9d4",
    },
  }),
  multiValue: (styles) => {
    return {
      ...styles,
      backgroundColor: "#606060",
    };
  },
  multiValueLabel: (styles) => ({
    ...styles,
    color: "#fff",
  }),
  multiValueRemove: (styles, { data }) => ({
    ...styles,
    color: "#000",
    "& > svg": {
      backgroundColor: "#fff",
      borderRadius: "10px",
      marginLeft: "2px",
      marginRight: "2px",
    },
    ":hover": {
      backgroundColor: data.color,
      color: data.color,
    },
  }),
  option: (styles, { data }) => {
    return {
      ...styles,
      backgroundColor: "white",
      color: "#000",
      ":hover": {
        backgroundColor: "#f5f5f5",
      },
    };
  },
};

const SupplierAdd = () => {
  const Navigate = useNavigate();

  const [initialValues] = useState({
    name: "",
    company_name: "",
    gst_number: "",
    email: "",
    phone: "",
    company_logo: "",
    supplier_type: "",
    machine_configuration: "",
    website: "",
  });

  const AddRole = useFormik({
    initialValues,
    validationSchema: SupplierAddSchema,

    onSubmit: (values, action) => {
      axios
        .post(`${process.env.REACT_APP_URL}/admin/offline_supplier`, values, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("Token")}`,
          },
        })
        .then((res) => {
          if (res.status === 200) {
            toast.success(`${res?.data?.message}`);
            Navigate("/admin/supplier/list", { state: res.data.msg });
          }
        })
        .catch((err) => {
          const errorMessage =
            err?.response?.data?.message ||
            err?.response?.data?.message ||
            "Something went wrong. Please try again.";

          toast.error(errorMessage);
        });
    },
  });

  //   const UserRole = () => {
  //     axios
  //       .get(`${process.env.REACT_APP_URL}/common/roles`)
  //       .then((res) => {
  //         setUserRole(res.data.roles);
  //       })
  //       .catch((err) => {
  //         if (err.response.data.message === "Unauthorized!") {
  //           Navigate("/admin/login");
  //         }
  //       });
  //   };

  useEffect(() => {
    // UserRole();
  }, []);

  return (
    <div className="al">
      <Toaster position="top-center" reverseOrder={false} />

      <div className="al-head">
        <div>
          <h1 className="al-title">Add Supplier</h1>
          <p className="al-sub">Register a new supplier with company and contact details.</p>
        </div>
        <div className="al-head__actions">
          <button type="button" className="al-btn" onClick={() => Navigate(-1)}>
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6" /></svg>
            Back
          </button>
        </div>
      </div>

      <form onSubmit={AddRole.handleSubmit}>
        <div className="al-card">
          <div className="al-cardhead">
            <div className="al-cardhead__icon"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" /><circle cx="12" cy="7" r="4" /></svg></div>
            <h3 className="al-cardhead__title">Supplier Details</h3>
          </div>

          <div className="al-form">
            <div>
              <label className="al-label">Business Type</label>
              <ReactSelect
                options={[
                  { label: "Manufacturer", value: "manufacturer" },
                  { label: "Trader", value: "trader" },
                  { label: "Retailer", value: "retailer" },
                ]}
                isClearable={false}
                styles={colourStyles}
                components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null }}
                placeholder="Select Supplier Type"
                name="supplier_type"
                onChange={(e) => AddRole.setFieldValue("supplier_type", e?.value)}
              />
              {AddRole.errors.supplier_type && AddRole.touched.supplier_type && (
                <div className="al-err">{AddRole.errors.supplier_type}</div>
              )}
            </div>

            <div>
              <label className="al-label">Name <span className="al-req">*</span></label>
              <input className="al-input" type="text" placeholder="Enter Name"
                value={AddRole.values.name} onChange={AddRole.handleChange} onBlur={AddRole.handleBlur} name="name" />
              {AddRole.errors.name && AddRole.touched.name && <div className="al-err">{AddRole.errors.name}</div>}
            </div>

            <div>
              <label className="al-label">Company Name</label>
              <input className="al-input" type="text" placeholder="Enter Company Name"
                value={AddRole.values.company_name} onChange={AddRole.handleChange} onBlur={AddRole.handleBlur} name="company_name" />
              {AddRole.errors.company_name && AddRole.touched.company_name && <div className="al-err">{AddRole.errors.company_name}</div>}
            </div>

            <div>
              <label className="al-label">GST Number</label>
              <input className="al-input" type="text" placeholder="Enter GST Number" style={{ fontFamily: "var(--font-mono)" }}
                value={AddRole.values.gst_number} onChange={AddRole.handleChange} onBlur={AddRole.handleBlur} name="gst_number" />
              {AddRole.errors.gst_number && AddRole.touched.gst_number && <div className="al-err">{AddRole.errors.gst_number}</div>}
            </div>

            <div>
              <label className="al-label">Email <span className="al-req">*</span></label>
              <input className="al-input" type="text" placeholder="Enter Email"
                value={AddRole.values.email} onChange={AddRole.handleChange} onBlur={AddRole.handleBlur} name="email" />
              {AddRole.errors.email && AddRole.touched.email && <div className="al-err">{AddRole.errors.email}</div>}
            </div>

            <div>
              <label className="al-label">Contact Number <span className="al-req">*</span></label>
              <input className="al-input" type="text" placeholder="Enter Contact Number" style={{ fontFamily: "var(--font-mono)" }}
                value={AddRole.values.phone} onChange={AddRole.handleChange} onBlur={AddRole.handleBlur} name="phone" />
              {AddRole.errors.phone && AddRole.touched.phone && <div className="al-err">{AddRole.errors.phone}</div>}
            </div>

            <div>
              <label className="al-label">Website</label>
              <input className="al-input" type="text" placeholder="Enter Website"
                value={AddRole.values.website} onChange={AddRole.handleChange} onBlur={AddRole.handleBlur} name="website" />
            </div>

            <div>
              <label className="al-label">Company Logo</label>
              <input className="al-input al-input--file" type="file" name="company_logo"
                onChange={AddRole.handleChange} onBlur={AddRole.handleBlur} />
              {AddRole.errors.company_logo && AddRole.touched.company_logo && <div className="al-err">{AddRole.errors.company_logo}</div>}
            </div>

            <div className="al-form__full">
              <label className="al-label">Machine Configuration</label>
              <input className="al-input" type="text" placeholder="Enter machine configuration"
                value={AddRole.values.machine_configuration} onChange={AddRole.handleChange} onBlur={AddRole.handleBlur} name="machine_configuration" />
            </div>
          </div>

          <div className="al-actionbar">
            <button type="button" className="al-btn" onClick={() => Navigate(-1)}>Cancel</button>
            <button type="submit" className="al-btn al-btn--primary">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round"><line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" /></svg>
              Create Supplier
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default SupplierAdd;
